import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput, NumberInput, ReferenceArrayInput, SelectArrayInput} from 'react-admin';
import {useTranslation} from "react-i18next";

function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <NumberInput source="kpiNumber" label={t('admin.kpiNumber')}/>
            <NumberInput source="foreignId" label={'foreignId'}/>
            <ReferenceArrayInput label={t('admin.efficiencyMetrics')} source="efficiencyMetrics"
                                 reference="dictionary/efficiency_metrics">
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </EditGuesser>
    )
}

export default Edit
